import React from 'react';

type ColSpan = 3 | 4 | 6 | 8 | 12;

type Props = {
  children: React.ReactNode;
  className?: string;
};

export function SettingsGrid({ children, className = '' }: Props) {
  return <div className={`settings-grid ${className}`.trim()}>{children}</div>;
}

type ColProps = {
  children: React.ReactNode;
  span?: ColSpan;
  className?: string;
};

export function SettingsCol({ children, span = 4, className = '' }: ColProps) {
  return (
    <div className={`settings-col settings-col--${span} ${className}`.trim()}>{children}</div>
  );
}
